import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
export function App() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: MetaPixelFunction = ((...args: unknown[]) => {
      if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
    }) as MetaPixelFunction;
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(pixelScript);
    fbq('init', '1785580659491412');
    fbq('track', 'PageView');
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="38kqd66tsabyd">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1785580659491412&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="38k6tolohjfi8" />
      </noscript>
      <div className="min-h-screen w-full bg-brand-blush text-brand-ink overflow-x-hidden flex flex-col items-center" data-id="element-2" data-mp="nxn71wrpjbph">
        <main className="w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="36hv93iy4lzn">
          <UrgencyBanner data-id="element-4" data-mp="34nabp7octvk" />
          <Hero data-id="element-5" data-mp="38b2ajxh1886" />
          <PainSection data-id="element-6" data-mp="3ud1en72ulk9k" />
          <SolutionSection data-id="element-7" data-mp="3ubrgkhvzwc2x" />
          <BonusSection data-id="element-8" data-mp="3ucjcjtti8btq" />
          <PricingCard data-id="element-9" data-mp="d4nxjm8nzu51" />
          <Guarantee data-id="element-10" data-mp="d57fv4288kjl" />
          <Testimonials data-id="element-11" data-mp="d3cu5nj4soeg" />
          <FAQ data-id="element-12" data-mp="d3wbb20yj8rf" />
          <FinalCTA data-id="element-13" data-mp="d2bh5dik1ru3" />
          <Footer data-id="element-14" data-mp="85ully910b6z" />
        </main>
      </div>
    </>;
}